import React, { PureComponent } from "react";

class Timestamp extends PureComponent {
  render() {
    return (
      <div className="timeline-box">
        <div className="date">{this.props.date}</div>
        <div className="content">
          {this.props.content}
          <div className="smallc">{this.props.note}</div>
        </div>
      </div>
    );
  }
}

const Timeline = () => (
  <section
    id="timeline"
    style={{ backgroundImage: "Url(images/section-background-02.jpg)" }}
  >
    <div className="container">
      <div className="section-title">
        <h2>Timeline</h2>
      </div>
      <div className="row">
        <p>
          Please note that I’m the Best Coder! Challenge Campus Edition 2020 has
          been postponed until further notice. A new timeline will be shared at
          a later date.
          <br />
          <br />
          Meanwhile, registration will remain open for all interested
          individuals. Sign up now before our slots get full!
        </p>
        {/* <div className="col-md-7 offset-md-3">
          <Timestamp date="20 Jan 2020" content="Registration Opens" />
          <Timestamp date="23 Feb 2020" content="Registration Closes" />
          <Timestamp
            date="End-Feb 2020"
            content="Series of Training Workshops*"
            note={
              "Confirmation will be sent to shortlisted individuals only. Selection is by random allocation. "
            }
          />
          <Timestamp
            date="13 Mar 2020"
            content="Challenge Day"
            // note="(Guest-of-Honour: Ms Sim Ann, Senior Minister of State, Ministry of Communications and Information & Ministry of Culture, Community and Youth)"
          />
        </div> */}
      </div>
      {/* <div className="section-footer">
      </div> */}
    </div>
  </section>
);

export default Timeline;
